import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthDispatchContext } from 'providers/Auth';

import { MessageEmailCheck } from '../components';
import { Loading } from 'components/ui';

const Success: FC = () => {
  // translations
  const { t } = useTranslation();
  // navigation
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // states
  const [isLoading, setLoading] = useState(true);
  // context
  const { verify } = useAuthDispatchContext();

  useEffect(() => {
    (async () => {
      try {
        const key = searchParams.get('key');

        if (!key) {
          throw new Error();
        } else {
          await verify(key);

          setLoading(false);
        }
      } catch (_) {
        navigate('/login');
      }
    })();
  }, [navigate, searchParams, verify]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <MessageEmailCheck title={t('auth.successfully_verified')}>
        <Button
          type="primary"
          shape="round"
          block
          onClick={() => navigate('/login')}
        >
          {t('auth.continue')}
        </Button>
      </MessageEmailCheck>
    </div>
  );
};

export default Success;
